export default __webpack_public_path__ + "static/media/password.630c81ea.svg";